module.exports = __webpack_public_path__ + "static/media/bp-logo.25b9f953.svg";